import { render } from "./WalletActityTo.vue?vue&type=template&id=d48f9ec0&scoped=true"
import script from "./WalletActityTo.vue?vue&type=script&lang=js"
export * from "./WalletActityTo.vue?vue&type=script&lang=js"

import "./WalletActityTo.vue?vue&type=style&index=0&id=d48f9ec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48f9ec0"]])

export default __exports__